import axios from 'axios'

export const http = axios.create({
    baseURL: 'https://test.cadastro.mtgtech.com.br/api'
});

